import { AlertDialog } from "@/components/ui/AlertDialog";
import type React from "react";
import { useCompleteVideoCall } from "../hooks/useCompleteVideoCall";

interface VideoCallModalConfirmationProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const VideoCallModalConfirmation: React.FC<
  VideoCallModalConfirmationProps
> = ({ isOpen, onOpenChange }) => {
  const { handleSuccessfulCompletion, handleUnsuccessfulCompletion } =
    useCompleteVideoCall();

  const onConfirm = () => {
    handleSuccessfulCompletion();
  };

  const onCancel = () => {
    handleUnsuccessfulCompletion();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isControlled
      title="Video Call Completion"
      body="Did the patient complete the video call?"
      actionLabel="Yes"
      cancelLabel="No"
      onAction={onConfirm}
      onCancel={onCancel}
      // TODO: Remove this once we fix the AlertDialogProvider
      // biome-ignore lint/complexity/noUselessFragments: We need to pass a trigger element to the AlertDialog so the AlertDialogProvider doesn't render the default trigger element
      triggerElement={<></>}
    />
  );
};
